export default "__VITE_ASSET__xjfJ_T$6__"